import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { JobsService } from '../../jobs/jobs.service';
import { IUserJob } from 'app/scheduler/core/IUserJob';
import { IFilter } from 'app/shared/interfaces/IFilter';
import { IFilterSelected } from 'app/shared/interfaces/IFilterSelected';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'user-jobs-list',
  templateUrl: 'user-jobs-list.component.html',
  styleUrls: ['user-jobs-list.component.scss']
})
export class UserJobsListComponent implements OnChanges, OnInit {
  public selectedFilterStatus: number = 0;
  public selectedFilterExecutionStatus: string = 'All';
  private _userJobs: Array<IUserJob> = [];
  @Input() filterExecutionStatus: boolean = true;
  @Input() currentUserJob: IUserJob;
  @Input()
  set userJobs(value: Array<IUserJob>) {
    this._userJobs = value ? value.slice().sort((a, b) => a.name.localeCompare(b.name)) : [];
  }
  get userJobs(): Array<IUserJob> {
    return this._userJobs;
  }
  @Output() onSetUserJob = new EventEmitter<IUserJob>();

  public searchValue: string;
  public selectedJob: IUserJob;
  public configurationFilter: IFilter[] = [];

  constructor(private _jobsService: JobsService, private _i18nService: I18nService) {

  }
  ngOnInit(): void {
    this.LoadFilterConfiguration();
  }

  ngOnChanges() {
    if (this.currentUserJob)
      this.setCurrentJob(this.currentUserJob);
  }

  public setCurrentJob(job: IUserJob) {
    this.selectedJob = job;
    this.onSetUserJob.emit(job);
  }

  isNextRuntimeYear9999(userJob: any): boolean {
    const nextRuntime = new Date(userJob.nextRuntime);
    return nextRuntime.getFullYear() === 9999;
  }

  shouldShowDateSection(userJob: IUserJob): boolean {
    return !this.isNextRuntimeYear9999(userJob) || userJob.rescheduleJob;
  }

  public setSelectedOption(type: number) {
    this.selectedFilterStatus = type;
  }

  onFilterChange(filterSelected: IFilterSelected[]) {
    if (filterSelected.length) {
      let executionStatusFilter = filterSelected.find(e => e.id == 'execution');
      let statusFilter = filterSelected.find(e => e.id == 'status');
      this.selectedFilterStatus = statusFilter.selected[0].value;
      this.selectedFilterExecutionStatus = executionStatusFilter.selected[0].value;
    }
  }
  lastExecutionStatus(job: IUserJob): string {
    switch (job.jobExecutionResult) {
      case true:
        return this._i18nService.instant('USERJOBS.SUCCESS');
      case false:
        return this._i18nService.instant('USERJOBS.FAIL');
      default:
        return this._i18nService.instant('USERJOBS.NOT_EXECUTED');
    }
  }

  lastExecutionStatusColors(job: IUserJob): string {
    switch (job.jobExecutionResult) {
      case true:
        return 'bmc-user-jobs-status-execution-success';
      case false:
        return 'bmc-user-jobs-status-execution-fail';
      default:
        return 'bmc-user-jobs-status-execution-not-executed';
    }
  }

  private LoadFilterConfiguration() {
    this.configurationFilter = [];

    this.configurationFilter.push({
      id: 'status',
      text: this._i18nService.instant('USERJOBS.JOB_FILTER_CONFIGURATION'),
      type: 'radioButton',
      options: [{
        text: this._i18nService.instant('USERJOBS.ALL'),
        value: 0,
        selected: true,
      }, {
        text: this._i18nService.instant('USERJOBS.ENABLED'),
        value: 1,
        selected: false,
      }, {
        text: this._i18nService.instant('USERJOBS.DISABLED'),
        value: 2,
        selected: false,
      }]
    })

    if (this.filterExecutionStatus) {
      this.configurationFilter.push({
        id: 'execution',
        text: this._i18nService.instant('USERJOBS.JOB_FILTER_EXECUTION_STATUS'),
        type: 'radioButton',
        options: [
          {
            text: this._i18nService.instant('USERJOBS.ALL'),
            value: 'All',
            selected: true,
          },
          {
            text: this._i18nService.instant('USERJOBS.NOT_EXECUTED'),
            value: 'null',
            selected: false,
          }, {
            text: this._i18nService.instant('USERJOBS.SUCCESS'),
            value: '1',
            selected: false,
          }, {
            text: this._i18nService.instant('USERJOBS.FAIL'),
            value: '0',
            selected: false,
          }]
      });
    }

  }
}
